import { render, staticRenderFns } from "./PolType.vue?vue&type=template&id=7a5cd1f9&"
import script from "./PolType.vue?vue&type=script&lang=js&"
export * from "./PolType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports